import React from 'react';
import "./FAQsHome.css";
import Btnz from './Btnz';

const FAQsHome = () => {
  return (
    <div className="cardfaqs">
      <h2>Does the app show ads for kids?</h2>
      <div className="custom-line"></div>
      <p className="textfaqs">
        This app is completely ad-free. We do not display third-party advertisements, pop-ups, or promotional content of any kind. Our goal is to provide a safe, focused, and uninterrupted experience for children, allowing them to explore, create, and play without distractions or commercial influence.
      </p>
      <div className="cbtn">
        <Btnz btn="Read more" />
      </div>
    </div>
  );
};

export default FAQsHome;
